<template>
  <!--我的客户页面-->
  <tk-container
    :status="status"
    :empty-message="'暂无客户数据'"
    :probeType="3"
    hide-status-bar
    @refresh="getInit"
    @scroll="watchScroll"
    style="background: #09a9f3;"
  >
    <!--头部-->
    <gradient-header slot="header"
                     class="reset-left-menu"
                     v-if="status !== 'empty'"
                     :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' }">我的客户</div>
      <!--终端添加客户-->
      <div slot="right-menu" v-if="isTerminalAccount">
        <div @click="$push('/itsMine/addClient')">
          <tk-icon size="24" material :color="isHeaderColor ? '#000000' : '#fff'">add_circle</tk-icon>
        </div>
      </div>
    </gradient-header>
    <my-header
      class="flex p-x-15"
      :style="{ paddingTop: statusBarHeight + 'px !important' }"
      v-if="status === 'empty'" slot="header"
    >
      我的客户
      <!--终端添加客户-->
      <div slot="right-menu" v-if="isTerminalAccount">
        <div @click="$push('/itsMine/addClient')">
          <tk-icon size="24" material>add_circle</tk-icon>
        </div>
      </div>
    </my-header>
    <!--累计订单金额最多用户-->
    <div style="height: 70px;"></div>
    <div class="m-x-10" v-if="maxOrder">
      <tk-flex middle
               class="card-top p-x-10"
               @click.native="nextRecords(maxOrder)"
      >
        <tk-image
          v-if="!isTerminalAccount"
          :src="'https://s3.moke.cloud/dianpei/0be717db-3122-4fbd-bcc1-cafb602d0cab.png'"
          width="37" height="41"></tk-image>
        <tk-flex middle between class="tk-grid-11 m-l-5 fill">
          <tk-flex column class="text-white full-width">
            <tk-flex
              between
              middle
              class="full-width"
              style="line-height: 1;"
            >
              <tk-flex middle>
                <div class="font-14 font-bold">{{maxOrder.name ? maxOrder.name : '客户'}}</div>
                <div class="font-12 m-l-10">{{maxOrder.phone}}</div>
              </tk-flex>
              <div class="font-10" style="color: rgba(177, 213, 247, 1);">{{isTerminalAccount ? '最近消费' : '累计金额'}}</div>
            </tk-flex>
            <tk-flex between middle class="font-12 m-t-4 full-width">
              <div class="van-ellipsis">{{$tkRegions.getFullName(maxOrder.region) + maxOrder.address}}</div>
              <div class="text-white font-bold font-16">
                <span class="font-10">￥</span>{{maxOrder.consumption}}
              </div>
            </tk-flex>
          </tk-flex>
        </tk-flex>
      </tk-flex>
    </div>
    <!--订单数据列表-->
    <div v-if="clientOrderData.length">
      <div
        class="m-x-20"
        v-for="(s, index) in clientOrderData"
        @click="nextRecords(s)"
        :key="index"
      >
        <tk-flex middle class="card-list p-y-12 p-x-15">
          <div class="tk-grid-1 m-r-5 class-card-wrap index-color font-12">{{index + 1 + 1}}</div>
          <tk-flex middle between class="tk-grid-11 fill">
            <tk-flex column middle class="tk-grid-9">
              <tk-flex bottom middle style="line-height: 1;">
                <div class="name-color font-14">{{s.name ? s.name : '客户'}}</div>
                <div class="name-color font-12 m-l-10">{{s.phone}}</div>
              </tk-flex>
              <div class="address-color m-t-4">
                {{$tkRegions.getFullName(s.region) +
                s.address}}
              </div>
            </tk-flex>
            <tk-flex right middle class="tk-grid-3 m-l-5">
              <div class="amount-color m-t-2 text-right class-card-wrap font-bold">
                <span class="font-10">￥</span>{{s.consumption}}
              </div>
              <tk-avatar size="18" class="m-l-5" v-if="!isTerminalAccount">
                <tk-image :src="'https://s3.moke.cloud/dianpei/69f2d492-15d5-409a-aa28-b499b807a164.png'" width="18" height="18"></tk-image>
              </tk-avatar>
            </tk-flex>
          </tk-flex>
        </tk-flex>
        <tk-flex>
          <div class="tk-grid-1 left-line-card"></div>
          <div class="right-line-card tk-grid-11"></div>
        </tk-flex>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      maxOrder: null, // 订单数最多的用户
      clientOrderData: [] // 统计客户记录
    }
  },
  computed: {
    ...mapState(['statusBarHeight'])
  },
  activated () {
    this.$store.commit('setSelectedData', [])
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * @Description: 页面初始化
     * @author xiaozan
     * @date 2020/5/5
     */
    async getInit () {
      try {
        await this.getMyClient() // 获取我的客户信息
        this.status = this.maxOrder ? false : 'empty'
        this.setStatusBar(this.status === 'empty' ? 'dark' : 'light')
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 终端统计客户金额
     */
    async groupClientMount () {
      let res = await this.$tkParse.group('/classes/consumptionRecords', 'client', {
        params: {
          select: {
            sum: {
              $sum: 'consumerAmount'
            }
          },
          where: {
            user: this.$store.state.user.objectId
          }
        }
      })
      return res.data.results
    },
    /**
    * 获取客户信息
    * @date: 2020/5/20
    */
    async getMyClient () {
      let obj = {
        limit: 20000,
        where: {
          merchants: this.userInfo.objectId
        }
      }
      if (this.isTerminalAccount) {
        obj.order = '-updatedAt'
      } else {
        obj.include = ['buyUser']
        obj.order = '-consumption'
      }
      let res = await this.$tkParse.getList('/classes/myClient', {
        params: obj
      })
      if (res.length) {
        if (!res[0].phone && !this.isTerminalAccount) {
          res[0].phone = res[0].buyUser.phone
        }
        if (this.isTerminalAccount) {
          let parseArr = await this.groupClientMount()
          res.forEach(s => {
            let findIndex = parseArr.findIndex(n => { return n.objectId === s.objectId })
            if (findIndex !== -1) {
              s.consumption = parseArr[findIndex].sum
            } else {
              s.consumption = 0
            }
          })
        }
        this.maxOrder = res[0]
        this.clientOrderData = res.splice(1)
      } else {
        this.maxOrder = null
        this.clientOrderData = []
      }
    },
    /**
     * @Description: 跳转查询消费记录
     * @author xiaozan
     * @date 2020/5/6
     */
    nextRecords (s) {
      if (this.isTerminalAccount) {
        this.$push({ path: '/itsMine/customerDetail', query: { id: s.objectId } })
      } else {
        this.$push({ path: '/itsMine/customerDetail', query: { id: s.buyUser.objectId } })
      }
    }
  },
  async hasFlash () {
    if (this.$getFlash('addStatus')) {
      await this.getInit()
    }
  }
}
</script>

<style scoped lang="scss">
  /*头部样式*/
  .flex {
    // height: 65px;
  }
  .reset-left-menu {
    ::v-deep .left-menu {
      margin-left: -13px;
    }
  }
  /*顶部样式*/
  .card-top {
    background:rgba(0,130,252,1);
    min-height: 100px;
    width: 100%;
    border-radius: 10px 10px 0 0;
    -webkit-box-shadow: 0 5px 5px rgba(0,0,0,0.3);
    box-shadow: 0 5px 5px rgba(0,0,0,0.3);
    -webkit-transform: perspective(300px);
    transform: perspective(300px);
  }
  /*列表样式*/
.card-list {
  width: 100%;
  min-height: 67px;
  background: #e9f2ff;
}
  .index-color {
    color: rgba(144, 189, 214, 1);
  }
  .name-color {
    color: rgba(3, 148, 232, 1);
  }
  .address-color {
    font-size: 12px;
    color: rgba(163, 172, 185, 1);
  }
  .amount-color {
    font-size: 17px;
    color: rgba(247, 165, 20, 1);
  }
  /*分割线*/
  .left-line-card {
    height: 1px;
    background: #e9f2ff
  }
  .right-line-card {
    height: 1px;
    background-color: rgba(212, 231, 240, 1);
  }
::v-deep .before-trigger {
  color: #fff !important;
}
</style>
